import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { MAX_WITNESS_NUMBER } from "src/config";
import { defaultWitnessFormikValues } from "src/storage";
import { AuthorityType, DataEntryAccidentStepSectionProps } from "src/types";
import {
  useAuthorityTypeOptions,
  useResponsiveBp,
  useYesNoAnswer,
} from "src/utils";

export const useDataEntryAccidentStepWitnesses = ({
  formikAccidentValues,
  formik,
}: DataEntryAccidentStepSectionProps) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveBp();
  const { authorityTypeOptions } = useAuthorityTypeOptions();
  const { yesNoOptions } = useYesNoAnswer();
  const { setFieldValue, setFieldError, setFieldTouched } = formik;

  const disableAddWitnesses =
    formikAccidentValues.witnessesInfo?.witnessesList?.length >=
    MAX_WITNESS_NUMBER;

  const onAddWitnessClick = () => {
    const currentWitnessesList =
      formikAccidentValues.witnessesInfo?.witnessesList || [];

    if (disableAddWitnesses) return;

    setFieldValue(
      "accidentData.witnessesInfo.witnessesList",
      [...currentWitnessesList, { ...defaultWitnessFormikValues }],
      false,
    );
  };

  const onRemoveWitnessClick = () => {
    const currentWitnessesList =
      formikAccidentValues.witnessesInfo?.witnessesList || [];

    if (currentWitnessesList.length === 0) return;

    setFieldValue("accidentData.witnessesInfo.witnessesList", [
      ...currentWitnessesList.slice(0, -1),
    ]);
  };

  const onSelectAuthorityInterventionQuestion = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const authorityInterventionQuestion = event.target.value;
    if (!authorityInterventionQuestion) return;

    setFieldValue("accidentData.witnessesInfo.authority", undefined);
    setFieldError("accidentData.witnessesInfo.authority", "");
    setFieldTouched("accidentData.witnessesInfo.authority", false, false);
  };

  const removeWitnessButtonVisible =
    formikAccidentValues.witnessesInfo?.witnessesList?.length > 0;

  return {
    isMobile,
    authorityTypeOptions,
    yesNoOptions,
    disableAddWitnesses,
    removeWitnessButtonVisible,
    t,
    onAddWitnessClick,
    onRemoveWitnessClick,
    onSelectAuthorityInterventionQuestion,
  };
};
